import React, { useRef, useCallback } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// FUNCTIONS
import { asyncFetch, doCallback, modalFunctions, sleep } from 'functions';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';
import Form from 'core/form/Form';

// STYLES
import styles from './addVin.module.scss';

// MAIN COMPONENT
const AddVin = () => {
  const { recordID } = useParams();

  const { refetchRecord } = useRecordContext() || {};

  const dailySalesInventoryId = useRef(null);

  const handleLoadVINOptions = async v => {
    const response = await asyncFetch({
      endpoint: ENDPOINTS.inventory.listOrder,
      params: {
        searchString: v
      }
    });
    return (response?.result || []).map(r => ({ label: r.inventory_display, value: r.daily_sales_inventory_id }));
  };

  const handleChange = useCallback(v => {
    dailySalesInventoryId.current = v;
  }, []);

  const handleClick = useCallback(() => {
    modalFunctions.add({
      type: 'form',
      title: 'Add VIN to Order',
      args: {
        method: 'PUT',
        endpoint: ENDPOINTS.sales.addVin(recordID),
        params: {
          daily_sales_inventory_id: dailySalesInventoryId.current
        },
        loadingMessage: 'Adding VIN',
        successMessage: 'VIN added',
        errorMessage: 'Unable to add VIN',
        onSuccess: async () => {
          await sleep(1000);
          doCallback(refetchRecord);
        },
        className: styles.form
      },
      fields: [
        <Form.Text className="large">
          Assign a VIN to this Order. When the VIN is assigned, the corresponding Stock # will be updated. Once the VIN
          is assigned, it cannot be changed.
        </Form.Text>,
        <Form.Select
          name="daily_sales_inventory_id"
          label="Search by VIN # or Stock #"
          placeholder="Search..."
          onLoadOptions={handleLoadVINOptions}
          onSelect={handleChange}
          className={styles.select}
          fullWidth
          required
        />
      ],
      cancelButton: {
        className: 'mb-4 mb-sm-0'
      },
      submitButton: {
        label: 'Confirm'
      },
      className: styles.modal,
      vertical: true,
      spacing: 'sm'
    });
  }, [handleChange, recordID, refetchRecord]);

  return <Button label="Add VIN" variant="warning" size="sm" fullWidth={false} onClick={handleClick} />;
};

// EXPORT
export default AddVin;
